// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/antd/dist/antd.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  overscroll-behavior-x: none;
  overscroll-behavior-y: none;
}

body {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.ant-layout-content {
  background: #ffffff;
}

.container {
  padding: 0 50px;
}
.container--dashboard {
  margin-top: 30px;
  margin-bottom: 30px;
}

.margin-right-10 {
  margin-right: 10px;
}

.ant-layout-sider-children {
  background-color: #2B2A77;
}

.mt10 {
  margin-top: 10px;
}

.ml10 {
  margin-left: 10px;
}

.mr10 {
  margin-right: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

label {
  display: inline-block;
  margin-bottom: 4px;
}

.input {
  position: relative;
  margin-bottom: 24px;
  width: 100%;
  margin-left: 5px;
  margin-right: 5px;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

.no-border {
  border: none;
  padding: 0;
  width: 95%;
  margin: 5px;
}
.no-border:focus {
  outline: none;
}

.border {
  border-style: solid;
  border-width: 0.5px;
  border-color: #818193;
  border-radius: 5px;
  display: inline-flex;
  width: 100%;
}
.border__eye {
  cursor: pointer;
}

.input-error {
  display: block;
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  color: #f5222d;
  font-size: 12px;
}

.login-form-forgot {
  float: right;
}

.profile {
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  overflow: auto;
  background: #ffffff;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.profile .content {
  width: 100%;
  padding: 30px;
}
.profile .avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.profile .change_avatar {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sider {
  background-color: #2B2A77 !important;
  min-width: 220px !important;
  padding: 5px;
}
.sider__menu {
  background-color: #2B2A77 !important;
}
.sider__menu__item {
  background-color: #2B2A77 !important;
  color: #B7B3D6;
}
.sider__menu .ant-menu-item-selected {
  background-color: #1E1D53 !important;
  color: #FFFFFF;
}
.sider__menu .ant-menu-sub {
  background-color: #2B2A77 !important;
}
.sider .ant-menu-inline, .sider .ant-menu-vertical, .sider .ant-menu-vertical-left {
  border-right: 0px !important;
}
.sider__logo {
  margin: 20px;
}
.sider__user {
  position: fixed;
  bottom: 0;
  margin: 20px;
}
.sider__user__content {
  display: flex;
  color: #FFFFFF;
  justify-content: center;
  align-items: center;
}
.sider__user__content__info {
  display: flex;
  flex-direction: column;
  margin: 5px;
}

.ant-layout-sider-trigger {
  display: none;
}

.site-layout {
  background-color: #F1F2F8;
}

.breadcrumb {
  margin: 30px 40px;
}

.body {
  padding: 0 30px;
}

.post .body .add-new {
  display: flex;
  justify-content: right;
  margin-bottom: 30px;
}
.post .action_button {
  display: flex;
  float: right;
}
.post .action_button button {
  margin: 30px;
  background-color: #302E90;
}
.post .preview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  padding: 50px;
}
.post .preview h3 {
  font-weight: 600;
}
.post .preview img {
  width: 80%;
}
.post .preview .content {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
  width: 80%;
  margin-top: 20px;
}

.login {
  background: #F1F2F8;
  min-height: 100vh;
}
.login .header {
  position: absolute;
  display: fixed;
  width: 100%;
  height: 290px;
  z-index: 1;
  left: 0px;
  top: 0px;
  background: #2B2A77;
}
.login .body {
  z-index: 99;
  margin-top: 100px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login .body .logo {
  z-index: 99;
  background-color: #2B2A77;
}
.login .body .logo .title {
  color: #FFFFFF;
}
.login .body .content {
  z-index: 99;
  background: #FFFFFF;
  width: 780px;
  border-radius: 8px;
  padding: 30px;
}

.tutorial .body .add-new {
  display: flex;
  justify-content: right;
  margin-bottom: 30px;
}
.tutorial .action_button {
  display: flex;
  float: right;
}
.tutorial .action_button button {
  margin: 30px;
  background-color: #302E90;
}
.tutorial .hashtag-parent {
  display: flex;
}
.tutorial .hashtag-item {
  color: #2C275F;
  margin-right: 5px;
}
.tutorial .preview {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  padding: 50px;
}
.tutorial .preview h3 {
  font-weight: 600;
}
.tutorial .preview img {
  width: 80%;
}
.tutorial .preview .content {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
  width: 80%;
  margin-top: 10px;
}

/* Make clicks pass-through */
#nprogress {
  pointer-events: none;
}

#nprogress .bar {
  background: #29d;
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
}

/* Fancy blur effect */
#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #29d, 0 0 5px #29d;
  opacity: 1;
  transform: rotate(3deg) translate(0px, -4px);
}

/* Remove these to get rid of the spinner */
#nprogress .spinner {
  display: block;
  position: fixed;
  z-index: 1031;
  top: 15px;
  right: 15px;
}

#nprogress .spinner-icon {
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: solid 2px transparent;
  border-top-color: #29d;
  border-left-color: #29d;
  border-radius: 50%;
  animation: nprogress-spinner 400ms linear infinite;
}

.nprogress-custom-parent {
  overflow: hidden;
  position: relative;
}

.nprogress-custom-parent #nprogress .spinner,
.nprogress-custom-parent #nprogress .bar {
  position: absolute;
}
@keyframes nprogress-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_layout.scss","webpack://./src/styles/main.scss","webpack://./src/styles/_form.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/pages/_profile.scss","webpack://./src/styles/pages/_layoutPage.scss","webpack://./src/styles/pages/_post.scss","webpack://./src/styles/pages/_login.scss","webpack://./src/styles/pages/_tutorial.scss","webpack://./src/styles/vendors/nprogress.scss"],"names":[],"mappings":"AAAA;;EAEC,2BAAA;EACA,2BAAA;ACED;;ADCA;EACC,wEAAA;ACED;;ADCA;EACC,mBAAA;ACED;;ADCA;EACC,eAAA;ACED;ADAC;EACC,gBAAA;EACA,mBAAA;ACEF;;ADaA;EACC,kBAAA;ACVD;;ADYA;EACC,yBAAA;ACTD;;ADYA;EACC,gBAAA;ACTD;;ADYA;EACC,iBAAA;ACTD;;ADYA;EACC,kBAAA;ACTD;;ADYA;EACC,mBAAA;ACTD;;AC7CA;EACC,qBAAA;EACA,kBAAA;ADgDD;;AC7CA;EACC,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;ADgDD;;AC7CA;EACI,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;ADgDJ;;AC7CA;EACC,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;ADgDD;AC9CC;EACC,aAAA;ADgDF;;AC5CA;EACC,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AD+CD;AC7CC;EACI,eAAA;AD+CL;;AC3CA;EACC,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,cC3CO;ED4CP,eAAA;AD8CD;;AC3CA;EACC,YAAA;AD8CD;;AGpGA;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AHuGD;AGrGC;EACC,WAAA;EACA,aAAA;AHuGF;AGpGC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AHsGF;AGpGC;EACC,gBAAA;EACA,mBAAA;AHsGF;;AI7HA;EACE,oCAAA;EACA,2BAAA;EACA,YAAA;AJgIF;AI/HE;EACE,oCAAA;AJiIJ;AI/HI;EACE,oCAAA;EACA,cAAA;AJiIN;AI9HI;EACE,oCAAA;EACA,cAAA;AJgIN;AI7HI;EACE,oCAAA;AJ+HN;AI3HE;EACE,4BAAA;AJ6HJ;AI1HE;EACE,YAAA;AJ4HJ;AIzHE;EACE,eAAA;EACA,SAAA;EACA,YAAA;AJ2HJ;AIzHI;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AJ2HN;AIzHM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AJ2HR;;AIrHA;EACE,aAAA;AJwHF;;AIrHA;EACE,yBAAA;AJwHF;;AIrHA;EACE,iBAAA;AJwHF;;AIrHA;EACE,eAAA;AJwHF;;AKrLI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;ALwLN;AKlLE;EACE,aAAA;EACA,YAAA;ALoLJ;AKlLI;EACE,YAAA;EACA,yBAAA;ALoLN;AKhLE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;ALkLJ;AKhLI;EACE,gBAAA;ALkLN;AK/KI;EACE,UAAA;ALiLN;AK9KI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;ALgLN;;AM3NA;EACC,mBAAA;EACA,iBAAA;AN8ND;AM5NC;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;AN8NF;AM3NC;EACC,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AN6NF;AM3NE;EACC,WAAA;EACA,yBAAA;AN6NH;AM3NG;EACC,cAAA;AN6NJ;AM1NE;EACC,WAAA;EAEA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AN2NH;;AOhQI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;APmQN;AO7PE;EACE,aAAA;EACA,YAAA;AP+PJ;AO7PI;EACE,YAAA;EACA,yBAAA;AP+PN;AO3PE;EACE,aAAA;AP6PJ;AO1PE;EACE,cAAA;EACA,iBAAA;AP4PJ;AOzPE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AP2PJ;AOzPI;EACE,gBAAA;AP2PN;AOxPI;EACE,UAAA;AP0PN;AOvPI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;APyPN;;AQ3SA,6BAAA;AACA;EACC,oBAAA;AR8SD;;AQ3SA;EACC,gBAAA;EAEA,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,WAAA;AR4SD;;AQzSA,sBAAA;AACA;EACC,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,uCAAA;EACA,UAAA;EAIA,4CAAA;AR2SD;;AQxSA,2CAAA;AACA;EACC,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;AR2SD;;AQxSA;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EAGA,kDAAA;ARySD;;AQtSA;EACC,gBAAA;EACA,kBAAA;ARySD;;AQtSA;;EAEC,kBAAA;ARySD;AQ9RA;EACC;IACC,uBAAA;ERySA;EQvSD;IACC,yBAAA;ERySA;AACF","sourcesContent":["html,\nbody {\n\toverscroll-behavior-x: none;\n\toverscroll-behavior-y: none;\n}\n\nbody {\n\tfont-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\n.ant-layout-content {\n\tbackground: #ffffff;\n}\n\n.container {\n\tpadding: 0 50px;\n\n\t&--dashboard {\n\t\tmargin-top: 30px;\n\t\tmargin-bottom: 30px;\n\t}\n}\n\n// .table-layout {\n// \t.ant-layout-content {\n// \t\tposition: absolute;\n// \t\ttop: 88px;\n// \t\tleft: 0;\n// \t\tright: 0;\n// \t\tbottom: 0;\n// \t\tz-index: 2;\n// \t}\n// }\n\n.margin-right-10 {\n\tmargin-right: 10px;\n}\n.ant-layout-sider-children {\n\tbackground-color: #2B2A77;\n}\n\n.mt10 {\n\tmargin-top: 10px;\n}\n\n.ml10 {\n\tmargin-left: 10px;\n}\n\n.mr10 {\n\tmargin-right: 10px;\n}\n\n.mb10 {\n\tmargin-bottom: 10px;\n}","@import 'variables';\n\n// components\n@import 'layout';\n@import 'form';\n\n//pages\n@import 'pages/profile';\n@import 'pages/layoutPage';\n@import 'pages/post';\n@import 'pages/login';\n@import 'pages/tutorial';\n\n//vendors\n@import 'vendors/nprogress';\n\n@import '~antd/dist/antd.css';\n","label {\n\tdisplay: inline-block;\n\tmargin-bottom: 4px;\n}\n\n.input {\n\tposition: relative;\n\tmargin-bottom: 24px;\n\twidth: 100%;\n\tmargin-left: 5px;\n\tmargin-right: 5px;\n}\n\nselect {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    text-indent: 1px;\n    text-overflow: '';\n}\n\n.no-border {\n\tborder: none;\n\tpadding: 0;\n\twidth: 95%;\n\tmargin: 5px;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n\n.border {\n\tborder-style: solid;\n\tborder-width: 0.5px;\n\tborder-color: #818193;\n\tborder-radius: 5px;\n\tdisplay: inline-flex;\n\twidth: 100%;\n\n\t&__eye {\n    \tcursor: pointer;\n\t}\n}\n\n.input-error {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: calc(100% + 2px);\n\tleft: 0;\n\tcolor: $redF5;\n\tfont-size: 12px;\n}\n\n.login-form-forgot {\n\tfloat: right;\n}\n","// colors\n$black: #000000;\n$white: #ffffff;\n$black33: #333333;\n$black34: #292d34;\n$black93: #818193;\n$redF5: #f5222d;\n$redEB: #eb5757;\n$greyE9: #e9ebf0;\n$greyF0: #f0f0f0;\n$greyEE: #eeeeee;\n$greyDA: #dadada;\n$greyC4: #c4c4c4;\n$greyF2: #f2f2f2;\n$grey62: #626262;\n$grey65: #656565;\n$greyCE: #cecece;\n$greyE6: #e6f7ff;\n$greyE6E9: #e6e9ef;\n$greyF5: #f0f2f5;\n$greyE8: #e8e8e8;\n$grey97: #979797;\n$greyF7: #f7f7f7;\n$greyFA: #fafafa;\n$greyD9: #d9d9d9;\n$greyED: #efefed;\n$grey8D: #7c828d;\n$greyFC: #fafbfc;\n$blue1C: #1c6ff7;\n$blueFF: #000000;\n$blue57: #1b1457;\n$green27A: #27ae60;\n$green0C: #0cac88;\n$yellow6E: #ffd66e;\n$yellowD4: #fff3d4;\n$ant-primary: #40a9ff;\n\n$small: 576px;\n$tablet: 768px;\n$desktop: 992px;\n$large-desktop: 1200px;\n",".profile {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-top: 50px;\n\toverflow: auto;\n\tbackground: #ffffff;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\n\t.content {\n\t\twidth: 100%;\n\t\tpadding: 30px;\n\t}\n\n\t.avatar {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t}\n\t.change_avatar {\n\t\tmargin-top: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n}\n",".sider {\n  background-color: #2B2A77 !important;\n  min-width: 220px !important;\n  padding: 5px;\n  &__menu {\n    background-color: #2B2A77 !important;\n\n    &__item {\n      background-color: #2B2A77 !important;\n      color: #B7B3D6;\n    }\n\n    .ant-menu-item-selected {\n      background-color: #1E1D53 !important;\n      color: #FFFFFF;\n    }\n\n    .ant-menu-sub {\n      background-color: #2B2A77 !important;\n    }\n  }\n\n  .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {\n    border-right: 0px !important;\n  }\n\n  &__logo {\n    margin: 20px;\n  }\n\n  &__user {\n    position: fixed;\n    bottom: 0;\n    margin: 20px;\n\n    &__content {\n      display: flex;\n      color: #FFFFFF;\n      justify-content: center;\n      align-items: center;\n\n      &__info {\n        display: flex;\n        flex-direction: column;\n        margin: 5px;\n      }\n    }\n  }\n}\n\n.ant-layout-sider-trigger {\n  display: none;\n}\n\n.site-layout {\n  background-color: #F1F2F8;\n}\n\n.breadcrumb {\n  margin: 30px 40px;\n}\n\n.body {\n  padding: 0 30px;\n}",".post {\n  .body {\n    .add-new {\n      display: flex;\n      justify-content: right;\n      margin-bottom: 30px;\n    }\n\n    \n  }\n\n  .action_button {\n    display: flex;\n    float: right;\n    \n    button {\n      margin: 30px;\n      background-color: #302E90;\n    }\n  }\n\n  .preview {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #FFFFFF;\n    padding: 50px;\n\n    h3 {\n      font-weight: 600;\n    }\n\n    img {\n      width: 80%;\n    }\n\n    .content {\n      display: flex;\n      flex-direction: column;\n      justify-content: left;\n      align-items:flex-start;\n      width: 80%;\n      margin-top: 20px;\n    }\n  }\n}",".login {\n\tbackground: #F1F2F8;\n\tmin-height:  100vh;\n\n\t.header {\n\t\tposition: absolute;\n\t\tdisplay: fixed;\n\t\twidth: 100%;\n\t\theight: 290px;\n\t\tz-index: 1;\n\t\tleft: 0px;\n\t\ttop: 0px;\n\t\tbackground: #2B2A77;\n\t}\n\n\t.body {\n\t\tz-index: 99;\n\t\tmargin-top: 100px;\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.logo {\n\t\t\tz-index: 99;\n\t\t\tbackground-color: #2B2A77;\n\n\t\t\t.title {\n\t\t\t\tcolor: #FFFFFF;\n\t\t\t}\n\t\t}\n\t\t.content {\n\t\t\tz-index: 99;\n\n\t\t\tbackground: #FFFFFF;\n\t\t\twidth: 780px;\n\t\t\tborder-radius: 8px;\n\t\t\tpadding: 30px;\n\t\t}\n\t}\n}",".tutorial {\n  .body {\n    .add-new {\n      display: flex;\n      justify-content: right;\n      margin-bottom: 30px;\n    }\n\n    \n  }\n\n  .action_button {\n    display: flex;\n    float: right;\n    \n    button {\n      margin: 30px;\n      background-color: #302E90;\n    }\n  }\n\n  .hashtag-parent {\n    display: flex;\n  }\n\n  .hashtag-item {\n    color: #2C275F;\n    margin-right: 5px;\n  }\n\n  .preview {\n    display: flex;\n    flex-direction: column;\n    background-color: #FFFFFF;\n    padding: 50px;\n\n    h3 {\n      font-weight: 600;\n    }\n\n    img {\n      width: 80%;\n    }\n\n    .content {\n      display: flex;\n      flex-direction: column;\n      justify-content: left;\n      align-items:flex-start;\n      width: 80%;\n      margin-top: 10px;\n    }\n  }\n}","/* Make clicks pass-through */\n#nprogress {\n\tpointer-events: none;\n}\n\n#nprogress .bar {\n\tbackground: #29d;\n\n\tposition: fixed;\n\tz-index: 1031;\n\ttop: 0;\n\tleft: 0;\n\n\twidth: 100%;\n\theight: 2px;\n}\n\n/* Fancy blur effect */\n#nprogress .peg {\n\tdisplay: block;\n\tposition: absolute;\n\tright: 0px;\n\twidth: 100px;\n\theight: 100%;\n\tbox-shadow: 0 0 10px #29d, 0 0 5px #29d;\n\topacity: 1;\n\n\t-webkit-transform: rotate(3deg) translate(0px, -4px);\n\t-ms-transform: rotate(3deg) translate(0px, -4px);\n\ttransform: rotate(3deg) translate(0px, -4px);\n}\n\n/* Remove these to get rid of the spinner */\n#nprogress .spinner {\n\tdisplay: block;\n\tposition: fixed;\n\tz-index: 1031;\n\ttop: 15px;\n\tright: 15px;\n}\n\n#nprogress .spinner-icon {\n\twidth: 18px;\n\theight: 18px;\n\tbox-sizing: border-box;\n\n\tborder: solid 2px transparent;\n\tborder-top-color: #29d;\n\tborder-left-color: #29d;\n\tborder-radius: 50%;\n\n\t-webkit-animation: nprogress-spinner 400ms linear infinite;\n\tanimation: nprogress-spinner 400ms linear infinite;\n}\n\n.nprogress-custom-parent {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.nprogress-custom-parent #nprogress .spinner,\n.nprogress-custom-parent #nprogress .bar {\n\tposition: absolute;\n}\n\n@-webkit-keyframes nprogress-spinner {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t}\n}\n@keyframes nprogress-spinner {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
